var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 81,
    viewBox: "0 0 75 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3415_16371)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3415_16371",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 69,
    height: 69
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 69,
    height: 69,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3415_16371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 46.25C14.5 41.2188 15.6979 36.7385 18.0938 32.8094C20.4896 28.8802 23.125 25.574 26 22.8906C28.875 20.2073 31.5104 18.1589 33.9062 16.7453L37.5 14.625V24.1125C37.5 25.8854 38.099 27.287 39.2969 28.3172C40.4948 29.3474 41.8365 29.8625 43.3219 29.8625C44.1365 29.8625 44.9151 29.6948 45.6578 29.3594C46.4005 29.024 47.0833 28.4729 47.7062 27.7063L49 26.125C52.45 28.1375 55.2292 30.9286 57.3375 34.4984C59.4458 38.0682 60.5 41.9854 60.5 46.25C60.5 50.4667 59.4698 54.312 57.4094 57.7859C55.349 61.2599 52.6417 64.0031 49.2875 66.0156C50.1021 64.8656 50.737 63.6078 51.1922 62.2422C51.6474 60.8766 51.875 59.4271 51.875 57.8937C51.875 55.9771 51.5156 54.1682 50.7969 52.4672C50.0781 50.7661 49.0479 49.2448 47.7062 47.9031L37.5 37.9125L27.3656 47.9031C25.976 49.2927 24.9219 50.826 24.2031 52.5031C23.4844 54.1802 23.125 55.9771 23.125 57.8937C23.125 59.4271 23.3526 60.8766 23.8078 62.2422C24.263 63.6078 24.8979 64.8656 25.7125 66.0156C22.3583 64.0031 19.651 61.2599 17.5906 57.7859C15.5302 54.312 14.5 50.4667 14.5 46.25ZM37.5 45.9625L43.6094 51.9281C44.424 52.7427 45.0469 53.6531 45.4781 54.6594C45.9094 55.6656 46.125 56.7438 46.125 57.8937C46.125 60.2417 45.2865 62.2422 43.6094 63.8953C41.9323 65.5484 39.8958 66.375 37.5 66.375C35.1042 66.375 33.0677 65.5484 31.3906 63.8953C29.7135 62.2422 28.875 60.2417 28.875 57.8937C28.875 56.7917 29.0906 55.7255 29.5219 54.6953C29.9531 53.6651 30.576 52.7427 31.3906 51.9281L37.5 45.9625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3415_16371",
    x: 0.5,
    y: 0.625,
    width: 74,
    height: 79.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.490196 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3415_16371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3415_16371",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.8253f1f6b1de6a6bdc381f312f92656f.svg";
export { ForwardRef as ReactComponent };